import { BenefitModalType } from './types'

export const openModal = (modal: BenefitModalType) => ({
  type: 'OPEN_MODAL' as const,
  payload: modal,
})

export const closeModal = () => ({
  type: 'CLOSE_MODAL' as const,
})

export type BenefitModalAction = ReturnType<typeof openModal> | ReturnType<typeof closeModal>
